import { IconCheck, IconX } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'
import { IconSparklesTwo } from '../icons'
import { cx } from '../../utils/cx'
import css from '../../styles/EditorV2.module.css'
import classes from './GenerationForm.module.css'

/**
 * The single-band states of the "ad generation with AI" component (Figma 84:4170):
 *   collapsed — "Ad Generation with AI" with a "Generate Ad" button ("filled close");
 *   success   — "Ad Generation with AI is Succeed" with the green Success button and close
 *               ("state6"). Draft-quality results and failures use the same band.
 */
export function GenerationBanner({ variant = 'success', message, onGenerate, onClose }) {
  const { t } = useTranslation()
  const subtitle = t('editorV2.generation.form.subtitle')
  if (variant === 'collapsed') {
    return (
      <div className={cx(css.card, classes.card)}>
        <div className={classes.band}>
          <span className={classes.tile}><IconSparklesTwo size={24} /></span>
          <span className={classes.bandText}>
            <span className={classes.bandTitle}>{t('editorV2.generation.form.title')}</span>
            <span className={classes.bandSubtitle}>{subtitle}</span>
          </span>
          <button type="button" className={cx(css.button, css.buttonPrimary)} style={{ height: 36 }} onClick={onGenerate}>
            {t('editorV2.generation.banner.generate')}
          </button>
        </div>
      </div>
    )
  }

  const tone = variant === 'draft' ? 'review' : (variant === 'failed' ? 'failed' : 'success')
  const title = t(`editorV2.generation.banner.${tone}Title`)
  const label = t(`editorV2.generation.banner.${tone}`)

  return (
    <div className={cx(css.card, classes.card)} role="status">
      <div className={classes.band}>
        <span className={classes.tile}><IconSparklesTwo size={24} /></span>
        <span className={classes.bandText}>
          <span className={classes.bandTitle}>{title}</span>
          <span className={classes.bandSubtitle}>{message || subtitle}</span>
        </span>
        <span className={classes.successButton} data-tone={tone === 'success' ? undefined : tone}>
          {tone === 'success' && <IconCheck size={16} stroke={2} aria-hidden="true" />}
          {label}
        </span>
        {onClose && (
          <button type="button" className={classes.close} aria-label={t('editorV2.generation.banner.close')} onClick={onClose}>
            <IconX size={24} stroke={1.6} />
          </button>
        )}
      </div>
    </div>
  )
}
